module.exports = __webpack_public_path__ + "static/media/Carmen Valencia-Castillo Headshot.11f93bf1.jpeg";